import authInstance from "../Interceptor/interceptor";

export const addFloorEffect = (formData) => {
  return authInstance.post("/floors/insert", formData);
};

export const deleteFloorEffect = (id) => {
  return authInstance.delete(`/floors/delete/${id}`);
};

export const editFloorEffect = (id, formData) => {
  return authInstance.put(`/floors/update/${id}`, formData);
};

export const viewFloorEffect = () => {
  return authInstance.get("/Floor/list");
};
export const listFloorEffect = ({ blockId, pageNo }) => {
  return authInstance.get(
    `floors/getlist?pagesize=10&pagination_required=false&block_id=${blockId}&pageNo=${pageNo}`
  );
};
export const listAllFloorEffect = (pageNo) => {
  return authInstance.get(
    `/floors/getfloorlist?pageNo=${pageNo}&pagesize=10&pagination_required=false`
  );
};
export const listAllFloor = (pageNo) => {
  return authInstance.get(
    `/floors/getfloorlist?pageNo=${pageNo}&pagesize=10&pagination_required=true`
  );
};

export const listCommonFloorEffect = () => {
  return authInstance.get("/common/floors");
};

